import React, { Component } from 'react';
import {
    Alert,

} from 'reactstrap';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import CompanyContext from '../../auth/CompanyContext';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

class BusinessDemographicsGraph extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);
        this.state = {
            newID: this.props.id,
            loading: false,
            data: [],
            labels: [],
            debug_message: null,
        };
    }

    renderData() {
        this.setState(
            { loading: true },
            () => { this.getDemographicsGraphData(); }
        );
    }

    // componentDidMount() {
    //    /* this.setState(
    //         { loading: true },
    //         () => { this.getDemographicsGraphData(); }
    //     );*/

    // }

    // componentDidUpdate(prevProps) {
    // }

    getDemographicsGraphData() {
        const body = JSON.stringify(this.props.groupSelections);

        fetch('/api/businessDemographicsGraph/', {
            method: 'POST',
            body,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {

                const graphStyles = {
                    fill: false,
                    tension: 0.1,
                    borderCapStyle: 'butt',
                    borderJoinStyle: 'miter',
                    pointBorderWidth: 1,
                    pointRadius: 2,
                    pointHoverRadius: 5,
                    pointHitRadius: 10,
                };
                const colors = ['#005c1e', '#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600'];

                let data = {
                    'Companies': {
                        ...graphStyles,
                        label: 'Companies',
                        borderColor: colors[0],
                        backgroundColor: colors[0],
                        pointBorderColor: colors[0],
                        data: []
                    },
                    'AUM Total Sum': {
                        ...graphStyles,
                        label: 'AUM Total Sum',
                        borderColor: colors[0],
                        backgroundColor: colors[0],
                        pointBorderColor: colors[0],
                        data: []
                    },
                    'HNW AUM Sum': {
                        ...graphStyles,
                        label: 'HNW AUM Sum',
                        borderColor: colors[1],
                        backgroundColor: colors[1],
                        pointBorderColor: colors[1],
                        data: []
                    },
                    'Individual AUM Sum': {
                        ...graphStyles,
                        label: 'Individual AUM Sum',
                        borderColor: colors[2],
                        backgroundColor: colors[2],
                        pointBorderColor: colors[2],
                        data: []
                    },
                    'Pension AUM Sum': {
                        ...graphStyles,
                        label: 'Pension AUM Sum',
                        borderColor: colors[3],
                        backgroundColor: colors[3],
                        pointBorderColor: colors[3],
                        data: []
                    },
                    'Non-Discretionary AUM Sum': {
                        ...graphStyles,
                        label: 'Non-Discretionary AUM Sum',
                        borderColor: colors[4],
                        backgroundColor: colors[4],
                        pointBorderColor: colors[4],
                        data: []
                    },
                    'Discretionary AUM Sum': {
                        ...graphStyles,
                        label: 'Discretionary AUM Sum',
                        borderColor: colors[5],
                        backgroundColor: colors[5],
                        pointBorderColor: colors[5],
                        data: []
                    },
                    'Total Accounts Sum': {
                        ...graphStyles,
                        label: 'Total Accounts Sum',
                        borderColor: colors[0],
                        backgroundColor: colors[0],
                        pointBorderColor: colors[0],
                        data: []
                    },
                    'HNW Accounts Sum': {
                        ...graphStyles,
                        label: 'HNW Accounts Sum',
                        borderColor: colors[1],
                        backgroundColor: colors[1],
                        pointBorderColor: colors[1],
                        data: []
                    },
                    'Individual Accounts Sum': {
                        ...graphStyles,
                        label: 'Individual Accounts Sum',
                        borderColor: colors[2],
                        backgroundColor: colors[2],
                        pointBorderColor: colors[2],
                        data: []
                    },
                    'Pension Accounts Sum': {
                        ...graphStyles,
                        label: 'Pension Accounts Sum',
                        borderColor: colors[3],
                        backgroundColor: colors[3],
                        pointBorderColor: colors[3],
                        data: []
                    },
                    'Non-Discretionary Accounts Sum': {
                        ...graphStyles,
                        label: 'Non-Descretionary Accounts Sum',
                        borderColor: colors[4],
                        backgroundColor: colors[4],
                        pointBorderColor: colors[4],
                        data: []
                    },
                    'Discretionary Accounts Sum': {
                        ...graphStyles,
                        label: 'Discretionary Accounts Sum',
                        borderColor: colors[5],
                        backgroundColor: colors[5],
                        pointBorderColor: colors[5],
                        data: []
                    },
                };
                let labels = [];
                // let debug_message = results.debug_message;
                results.data.forEach(row => {
                    data['Companies'].data.push(row['Companies'] !== null ? row['Companies'] : 0);
                    data['AUM Total Sum'].data.push(row['AUM Total Sum'] !== null ? row['AUM Total Sum'] : 0);
                    data['HNW AUM Sum'].data.push(row['HNW AUM Sum'] !== null ? row['HNW AUM Sum'] : 0);
                    data['Individual AUM Sum'].data.push(row['Individual AUM Sum'] !== null ? row['Individual AUM Sum'] : 0);
                    data['Pension AUM Sum'].data.push(row['Pension AUM Sum'] !== null ? row['Pension AUM Sum'] : 0);
                    data['Non-Discretionary AUM Sum'].data.push(row['Non-Discretionary AUM Sum'] !== null ? row['Non-Discretionary AUM Sum'] : 0);
                    data['Discretionary AUM Sum'].data.push(row['Discretionary AUM Sum'] !== null ? row['Discretionary AUM Sum'] : 0);
                    data['Total Accounts Sum'].data.push(row['Total Accounts Sum'] !== null ? row['Total Accounts Sum'] : 0);
                    data['HNW Accounts Sum'].data.push(row['HNW Accounts Sum'] !== null ? row['HNW Accounts Sum'] : 0);
                    data['Individual Accounts Sum'].data.push(row['Individual Accounts Sum'] !== null ? row['Individual Accounts Sum'] : 0);
                    data['Pension Accounts Sum'].data.push(row['Pension Accounts Sum'] !== null ? row['Pension Accounts Sum'] : 0);
                    data['Non-Discretionary Accounts Sum'].data.push(row['Non-Discretionary Accounts Sum'] !== null ? row['Non-Discretionary Accounts Sum'] : 0);
                    data['Discretionary Accounts Sum'].data.push(row['Discretionary Accounts Sum'] !== null ? row['Discretionary Accounts Sum'] : 0);
                    labels.push(row['Month'] + '/' + row['Year']);
                });

                this.setState({
                    loading: false,
                    data,
                    labels,
                    debug_message: results.debug_message ?? null
                });
            });
    }


    render() {
        if (!this.state.loading && this.state.data.length === 0) {
            return (<></>)
        } else if (this.state.loading === true || this.state.data.length === 0 || typeof (this.state.data) === 'undefined') {
            return (
                <><Alert color="info">
                    Loading graphs - please be patient, this may take a minute...
                </Alert></>
            )
        } else {
            //return (<></>)
            const moneyScale = {
                beginAtZero: true,
                ticks: {
                    callback: (v) => '$' + v.toString().split(/(?=(?:...)*$)/).join(',')
                }
            };

            // Chart.js v4 options
            const commonOpts = {
                responsive: true,
                maintainAspectRatio: false,   // helps prevent ResizeObserver loop warning
                animation: false,
                plugins: { legend: { position: 'top' } },
                scales: { y: { beginAtZero: true } },
            };

            const moneyOpts = { ...commonOpts, scales: { y: moneyScale } };

            const companiesData = {
                labels: this.state.labels,
                datasets: [
                    this.state.data['Companies'],
                ]
            };
            const AUMdata = {
                labels: this.state.labels,
                datasets: [
                    this.state.data['AUM Total Sum'],
                    this.state.data['Non-Discretionary AUM Sum'],
                    this.state.data['Discretionary AUM Sum'],
                ]
            };
            const AUMdata2 = {
                labels: this.state.labels,
                datasets: [
                    this.state.data['HNW AUM Sum'],
                    this.state.data['Individual AUM Sum'],
                    this.state.data['Pension AUM Sum'],
                ]
            };
            // const AUMoptions = {
            //     scales: {
            //         yAxes: [{
            //             ticks: {
            //                 beginAtZero: true,
            //                 userCallback: function (value, index, values) {
            //                     value = value.toString();
            //                     value = value.split(/(?=(?:...)*$)/);
            //                     value = value.join(',');
            //                     return '$' + value;
            //                 }
            //             }
            //         }]
            //     },
            // }
            const accountsData = {
                labels: this.state.labels,
                datasets: [
                    this.state.data['Total Accounts Sum'],
                    this.state.data['Non-Discretionary Accounts Sum'],
                    this.state.data['Discretionary Accounts Sum'],
                ]
            };
            const accountsData2 = {
                labels: this.state.labels,
                datasets: [
                    this.state.data['HNW Accounts Sum'],
                    this.state.data['Individual Accounts Sum'],
                    this.state.data['Pension Accounts Sum'],
                ]
            };
            return (
                <>
                    <h4>Companies</h4>
                    <div style={{ height: 565 }}><Line data={companiesData} options={commonOpts} resizedelay={200} /></div>

                    <h4>AUM</h4>
                    <div style={{ height: 565 }}><Line data={AUMdata} options={moneyOpts} resizedelay={200} /></div>
                    <div style={{ height: 565 }}><Line data={AUMdata2} options={moneyOpts} resizedelay={200} /></div>

                    <h4>Accounts</h4>
                    <div style={{ height: 565 }}><Line data={accountsData} options={commonOpts} resizedelay={200} /></div>
                    <div style={{ height: 565 }}><Line data={accountsData2} options={commonOpts} resizedelay={200} /></div>
                </>
            );
        }
    }
}



export default BusinessDemographicsGraph;
